module.exports = __webpack_public_path__ + "static/media/Hbook-11.094f9f03.jpg";